window.initShopListBanners = () => {
  const shopList = document.querySelector(".product-grid");
  const bannerWraps = document.querySelectorAll(".shop_list_banner_wrap");

  if (!shopList || bannerWraps.length === 0) return;

  shopList.querySelectorAll(".shop_list_banner_item").forEach((banner) => {
    banner.remove();
  });

  const products = shopList.querySelectorAll("li.grid__item");
  const productCount = products.length;
  const banners = Array.from(bannerWraps)
    .map((bannerWrap) => ({
      html: bannerWrap.innerHTML,
      order: Number.parseInt(bannerWrap.dataset.order, 10),
    }))
    .filter((banner) => Number.isInteger(banner.order) && banner.order > 0)
    .sort(
      (firstBanner, secondBanner) => firstBanner.order - secondBanner.order,
    );

  bannerWraps.forEach((bannerWrap) => {
    bannerWrap.hidden = true;
  });

  if (banners.length === 0) return;

  banners.forEach(({ html: bannerHtml, order }) => {
    const bannerItem = document.createElement("li");
    bannerItem.className = "grid__item shop_list_banner_item";
    bannerItem.innerHTML = bannerHtml;

    const target = products[order - 1];
    if (target) {
      shopList.insertBefore(bannerItem, target);
    } else if (productCount > 0) {
      shopList.append(bannerItem);
    }
  });
};

window.initShopListBanners();
